module.exports = __webpack_public_path__ + "media/images/icons/dial-c16870d8bd79b84c6e4f45a2d8115e31.svg";